// extracted by mini-css-extract-plugin
export default {"main":"login_main_rAQvC","arrow":"login_arrow_NClOV"};